module.exports = __webpack_public_path__ + "static/media/unisky.87e68330.jpg";